<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t('v4.TRANSACTION HISTORY') }}</h4>
            </div>
        </div>
        <div class="b-table-sticky-header table-responsive">
            <b-table-simple
                no-border-collapse
            >
                <b-thead>
                    <b-tr>
                        <b-th>
                            {{ $t('v4.Month') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4.Service Name') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4["Order No."]') }}
                        </b-th>
                        <b-th class="text-right">
                            {{ $t('v4.Amount') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4.Payment Date') }}
                        </b-th>
                        <b-th>
                            {{ $t('v4.Status') }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody v-if="data.length > 0">
                    <b-tr v-for="(item, index) in data" :key="index">
                        <b-td>
                            {{ item.month }}
                        </b-td>
                        <b-td>
                            {{ item.service }}
                        </b-td>
                        <b-td>
                            {{ item.orderNo }}
                        </b-td>
                        <b-td class="text-right">
                            {{ $_getWon(item.amount) }}
                        </b-td>
                        <b-td>
                            {{ item.createdt }}
                        </b-td>
                        <b-td>
                            <b-badge variant="success" v-if="item.status === 'PAID'">{{ $t('v4.Completed') }}</b-badge>
                            <b-badge variant="danger" v-else>{{ $t('v4.Cancelled') }}</b-badge>
                        </b-td>
                    </b-tr>
                </b-tbody>
                <b-tbody v-else>
                    <b-tr>
                        <b-td colspan="6" class="pb-50 pt-2 text-center">
                            {{ $t('v4["There is no billing history."]') }}
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </b-card>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    thead:first-child {
        tr:first-child {
            th {
                border-top: 0
            }
        }
    }
}
</style>
